export default __webpack_public_path__ + "static/media/team-img-3.d285f347.webp";